import { ID, Response } from './../../../_metronic/helpers/crud-helper/models';
import { _pHttp } from "../_pHttp";

// دانلود اکسل هواداران ویژه
export const downloadFanReportPerMatchExcel = async (matchId: number) => {
    try {
      const response = await _pHttp.get(
        `tickets/sales/${matchId}`,
        {
          responseType: "arraybuffer",
        }
      );
  
      const contentType =
        response.headers["content-type"] ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([response.data], { type: contentType });
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      // const today = moment();
      // const formattedDate = today.format("YYYY-M-D");
  
      a.href = url;
      a.download = `matchId-${matchId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      // Handle error (e.g., show error message to user)
    }
  };

// گزارش بدون قیمت
export const getMatchReportWithoutPrice = async (id: number) => {
    const response = await _pHttp.get(`ticket-matches/report/without-price/${id}`);
    return response.data;
};

// دانلود اکسل گزارش بدون قیمت
export const downloadMatchReportWithoutPriceExcel = async (matchId: number) => {
    try {
      const response = await _pHttp.get(
        `ticket-matches/report/without-price/excel/${matchId}`,
        {
          responseType: "arraybuffer",
        }
      );
  
      const contentType =
        response.headers["content-type"] ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([response.data], { type: contentType });
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `match-report-${matchId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
};

interface CheckAttendeesResponse {
  total: number
  valid: number
  invalid: {
    total: number
    records: any[]
  }
  status: string
}

export const checkSpecialTicketAttendees = async (file: File, organizationId: number) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('organizationId', String(organizationId))

  const response = await _pHttp.post<CheckAttendeesResponse>(
    'tickets/special/checkAttendees',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}

export const submitSpecialTicketExcel = async (file: File, organizationId: number, male: boolean) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('organizationId', String(organizationId))
  formData.append('male', male ? 'true' : 'false')
  
  const response = await _pHttp.post(
    'tickets/special/excel',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}

export const getWomenFanExcelReportList = async () => {
  try {
    const response = await _pHttp.get(
      `fan-cards/report/details`,
      {
        responseType: "arraybuffer",
      }
    );
    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `fan-cards-report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};